import React from 'react';
import styled from 'styled-components';
import { RESERVED_TAGS } from '../../../constants/constants';
import thumbDownGreyButton from '../../../images/thumbs-down-grey.png';
import thumbUpGreyButton from '../../../images/thumbs-up-grey.png';
import {
  getRetrievalTagValue,
  isRetrievalTag
} from '../../../utils/tagValidatorUtils';
import LabelSpan from './LabelSpan';

interface TagSpanProps {
  $isEmptyInput: boolean;
}

const TagSpan = styled(LabelSpan)<TagSpanProps>`
  color: ${(props) =>
    props.$isEmptyInput ? 'var(--color-gray)' : 'var(--color-brand24-purple)'};
  background: ${(props) =>
    props.$isEmptyInput ? 'transparent' : 'var(--color-medium-gray)'};
  padding: ${(props) => (props.$isEmptyInput ? 'unset' : '2px 12px 2px 10px')};
  border-radius: ${(props) => (props.$isEmptyInput ? 'unset' : '6px')};
  display: ${(props) => (props.$isEmptyInput ? 'inline-block' : 'block')};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  width: fit-content;
`;

const TagDiv = styled.div`
  padding: 2px 5px;
  border-radius: 5px;
  width: fit-content;
  background-color: var(--color-soft-gray);
  color: var(--color-black);
  font-size: var(--font-size-400);
  border: none;
  word-break: break-word;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

  &:hover {
    background-color: ${(props) =>
      props.onClick ? 'var(--color-white)' : 'var(--color-soft-gray)'};
  }
`;

const renderTag = (
  content: string | undefined,
  isEmpty: boolean,
  source?: string,
  onTagClick?: () => void
) => {
  if (source === 'PDF') {
    return (
      <TagDiv {...(onTagClick && { onClick: onTagClick })}>{content}</TagDiv>
    );
  }
  return (
    <TagSpan
      {...(onTagClick && { onClick: onTagClick })}
      $isEmptyInput={isEmpty}
    >
      {content}
    </TagSpan>
  );
};

interface TagLabelProps {
  tag: string | undefined;
  flashflag: boolean;
  onTagClick: () => void;
  source?: string; // source is used to identify the component that calls TagLabel
}

const TagLabel: React.FC<TagLabelProps> = ({
  tag,
  flashflag,
  onTagClick,
  source
}) => {
  const { DOWNTAG, UPTAG, UNTAGGED } = RESERVED_TAGS;

  if (tag === UPTAG) {
    return <img src={thumbUpGreyButton} alt="Thumb Up" />;
  }
  if (tag === DOWNTAG) {
    return <img src={thumbDownGreyButton} alt="Thumb Down" />;
  }

  if (
    tag === '' ||
    tag === UNTAGGED ||
    (tag === RESERVED_TAGS.FLASH && flashflag)
  ) {
    return renderTag('Add Tag', true, source, onTagClick);
  }

  if (isRetrievalTag(tag) || tag === RESERVED_TAGS.MY_AUDIO_FEEDBACK) {
    const content = isRetrievalTag(tag) ? getRetrievalTagValue(tag) : tag;
    return renderTag(content, false, source);
  }

  return renderTag(tag, false, source, onTagClick);
};

export default TagLabel;
